import api from "@/services/api";
import { ENDPOINTS_INVOICES } from "@/services/endpoints";

export const listInvoices = () => api.get(ENDPOINTS_INVOICES.list).then((r) => r.data);

export const createInvoice = (payload) =>
  api.post(ENDPOINTS_INVOICES.create, payload).then((r) => r.data);

export const getInvoice = (id) => api.get(ENDPOINTS_INVOICES.detail(id)).then((r) => r.data);

export const downloadInvoicePdf = (id) =>
  api.get(`${ENDPOINTS_INVOICES.detail(id)}/pdf`, { responseType: "blob" }).then((r) => r.data);

export const sendInvoice = (id) => api.post(ENDPOINTS_INVOICES.send(id)).then((r) => r.data);

export const cancelInvoice = (id, body) => api.post(ENDPOINTS_INVOICES.cancel(id), body).then((r) => r.data);

export const payInvoice = (id, payload) =>
  api.post(ENDPOINTS_INVOICES.pay(id), payload).then((r) => r.data);

export const confirmFundInvoice = (id) =>
  api.post(ENDPOINTS_INVOICES.fundConfirm(id)).then((r) => r.data);

export const claimInvoice = (id) => api.post(ENDPOINTS_INVOICES.claim(id)).then((r) => r.data);

export const confirmClaimInvoice = (id) =>
  api.post(ENDPOINTS_INVOICES.claimConfirm(id)).then((r) => r.data);

export const disputeInvoice = (id, payload) =>
  api.post(ENDPOINTS_INVOICES.dispute(id), payload).then((r) => r.data);
